<template>
  <div class="partsPrice-container">配件价格</div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.partsPrice-container {
  padding: 5%;
}
</style>
